import { Button, Modal } from "@themesberg/react-bootstrap";
import React, { useState } from "react";
import CustomTable from "../../../components/CustomTable";
import { formatNumber } from "../../../redux/utils";
import { accountTypes, bankList } from "../../accounts/AccountForm";
import { createToken, createTokenPin, postApi } from "../../../redux/api";
import toast from "react-hot-toast";
import CustomButton from "../../../components/CustomButton";
import { useNavigate } from "react-router-dom";
import { Routes } from "../../../routes";

function PaymentPreviewModal1({
  toggle = (f) => f,
  isOpen = false,
  paymentList = [],
  data = [],
  goBackFun = (f) => f,
}) {
  const [pin, setPin] = useState("1234");
  const [loading, setLoading] = useState(false);
 const navigate = useNavigate();
  const processPayment = () => {
    if (pin.length < 4) {
      alert("PIN is 4 digit");
    } else {
      console.log(paymentList);
      // alert('workin');
      setLoading(true);
      const finalList = [];
      data.forEach((payment) => {
        let new_amount =
          (payment.approvalInfo ? payment.approvalInfo.cb_amount : 0) * 100;
        let input_amount = new_amount?.toString().split(".")[0];
        finalList.push({
          amount: payment.amount,
          approval_date: payment.date,
          economic_code: payment.economic_code,
          mda_code: payment.mda_code,
          description: payment.description,
          destination_acct_name: payment.contractor_acc_name,
          destination_acct_no: payment.contractor_acc_no,
          source_account_name: payment.payment_account_name,
          source_account_no: payment.payment_account,
        });
        // alert(JSON.stringify(finalList));
        postApi(`post_transfer_array?query_type=funding_transfer`, {
          finalList,
        })
          .then((data) => {
            console.log(data);
            toggle();
            // handleReset();
            setLoading(false);
            navigate(-2);
          })
          .catch((error) => {
            console.error(error);
            setLoading(false);
          });
      });

      // console.log(finalList);
    }
  };

  return (
    <Modal show={isOpen} onHide={toggle} size="xl">
      <Modal.Header>
        <h4>Confirm Payment Selection</h4>
      </Modal.Header>
      <Modal.Body>
        {/* {JSON.stringify(paymentList)} */}
        <div className="col-md-4 pb-1 mb-1">
          {/* <input
            onChange={({ target: { value } }) => {
              setPin(value);
            }}
            value={pin}
            name="pin-st"
            type="password"
            required
            maxLength="4"
            className="form-control"
            placeholder="Enter PIN"
          /> */}
        </div>
        {/* <div>{JSON.stringify(paymentList[1]?.pvInfo?.mda_code)}</div> */}
        <CustomTable
          responsive
          fields={[
            { title: "S/N", custom: true, component: (s, d) => d + 1 },
            {
              title: "Account Name",
              custom: true,
              component: (item) => item.pvInfo.contractor_acc_name,
            },
            {
              title: "Account Number",
              custom: true,
              component: (item) => item.pvInfo.contractor_acc_no,
            },
            {
              title: "Account Type",
              custom: true,
              component: (item) =>
                item.pvInfo
                  .account_type /**=== "20" ? "Current Account" : item.pvInfo.account_type === "10" ? "Savings Account" : "Defualt" */,
            },
            {
              title: "Bank Name",
              custom: true,
              component: (item) => item.pvInfo.contractor_bank,
            },
            {
              title: "Narration",
              custom: true,
              component: (item) => item.pvInfo.description,
            },
            {
              title: "Amount",
              custom: true,
              component: (item) => (
                <div className="text-end">
                  {item.approvalInfo
                    ? formatNumber(item.approvalInfo.cb_amount)
                    : "0"}
                </div>
              ),
            },
          ]}
          data={paymentList}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button color="danger" onClick={goBackFun}>
          Cancel
        </Button>
        <CustomButton loading={loading} onClick={processPayment}>
          Confirm
        </CustomButton>
      </Modal.Footer>
    </Modal>
  );
}

export default PaymentPreviewModal1;
